"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Commander Spellbook API
 * API for Commander Spellbook, the combo database engine for Magic: The Gathering
 *
 * The version of the OpenAPI document: 4.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPatchedUserDetailRequest = instanceOfPatchedUserDetailRequest;
exports.PatchedUserDetailRequestFromJSON = PatchedUserDetailRequestFromJSON;
exports.PatchedUserDetailRequestFromJSONTyped = PatchedUserDetailRequestFromJSONTyped;
exports.PatchedUserDetailRequestToJSON = PatchedUserDetailRequestToJSON;
exports.PatchedUserDetailRequestToJSONTyped = PatchedUserDetailRequestToJSONTyped;
/**
 * Check if a given object implements the PatchedUserDetailRequest interface.
 */
function instanceOfPatchedUserDetailRequest(value) {
    return true;
}
function PatchedUserDetailRequestFromJSON(json) {
    return PatchedUserDetailRequestFromJSONTyped(json, false);
}
function PatchedUserDetailRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'password': json['password'] == null ? undefined : json['password'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
    };
}
function PatchedUserDetailRequestToJSON(json) {
    return PatchedUserDetailRequestToJSONTyped(json, false);
}
function PatchedUserDetailRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'password': value['password'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
    };
}
//# sourceMappingURL=patchedUserDetailRequest.js.map